import { loader } from 'graphql.macro';
import { Nullable } from 'common-types';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { logger } from 'logging-utils';
import { EmailVerification } from '../../email-verification-types';

const mutation = loader('./send-email-verification.gql');

const sendEmailVerification = (client: ApolloClient<NormalizedCacheObject>) => {
  return {
    execute: async (): Promise<Nullable<EmailVerification>> => {
      try {
        const results = await client.mutate<EmailVerificationResponse>({
          mutation,
        });

        if (!results.data) {
          throw new Error('failed to send verification email');
        }

        return results.data.sendEmailVerification;
      } catch (error) {
        logger.error(
          'Failed sending verification email due to an error',
          error,
        );
        return null;
      }
    },
  };
};

interface EmailVerificationResponse {
  sendEmailVerification: EmailVerification;
}

export default sendEmailVerification;
